export function gpxLog(name: string, data: any = {}) {
	Mapy.getComponent("logger").log(name, {
		section: "import",
		...data,
	});
}

export function getFolderIdFromMyMaps(): string {
	const mymapsComp = Mapy.getComponent("mymaps");

	if (mymapsComp.isActive()) {
		const state = mymapsComp.getState();

		if (state.mid) {
			return state.mid;
		}
	}

	return "";
}
